// src/modules/app-views/suppliers/pages/Document/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import {
  dropdownParameters,
  dropdownDivider,
  dropdownNew,
  dropdownDuplicate,
  dropdownArchive,
  dropdownRemove,
  dropdownRestore,
  dropdownRemovePermanently,
} from 'layouts/Pages/PageHeader/dropdownMenus';
import { MoreOutlined } from '@ant-design/icons';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const suppliersDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',

    dropdownItems: [
      dropdownNew,
      dropdownDuplicate,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,

      'divider',

      dropdownParameters,
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default suppliersDocumentMenuButton;
